import { useConfig } from "@jti/app-context/useConfig";
import { SimpleProductTeaser as UISimpleProductTeaser } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/SimpleProductTeaser/SimpleProductTeaser";
import { SimpleProductTeaser as MobileFirstUISimpleProductTeaser } from "@jti/ui/eva-components/MobileFirstHeader/components/SecondaryNavigation/components/SimpleProductTeaser";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import type { ProductsMap } from "@/libs/commerce/products";
import { getResizedImageUrl } from "@/utils/getResizedImageUrl";

import type { simpleProductTeaserInputs } from "./SimpleProductTeaser.builder";

type SimpleProductTeaserProps = BuilderComponentProps<typeof simpleProductTeaserInputs>;

export function SimpleProductTeaser({
  name,
  src,
  link,
  products,
  sku,
}: SimpleProductTeaserProps & { products: ProductsMap }) {
  const { __ } = useTranslations();
  const { isMobileFirstNavigationEnabled } = useConfig();
  const SimpleProductTeaserComponent = isMobileFirstNavigationEnabled
    ? MobileFirstUISimpleProductTeaser
    : UISimpleProductTeaser;
  const productData = products?.[sku?.options?.product];

  if (!productData) {
    return null;
  }

  return (
    <SimpleProductTeaserComponent
      name={name || productData.title || ""}
      src={src || getResizedImageUrl(productData.image) || ""}
      link={{
        href: link?.href || productData.pageUrl || "/",
        text: link?.text || __("product.button.buynow"),
      }}
      alt={name || productData.title || ""}
    />
  );
}
